import { render, staticRenderFns } from "./CoreValuesSixIcon.vue?vue&type=template&id=6d33a8c6&"
import script from "./CoreValuesSixIcon.vue?vue&type=script&lang=js&"
export * from "./CoreValuesSixIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports